module.exports = __webpack_public_path__ + "static/media/spin_mclaren.e72c18b0.png";